/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import Collapsible from 'react-collapsible';

interface IProps {
  product?: any;
  parentProduct?: any;
}

 class Disclaimers extends React.Component<IProps> {
   constructor(props: IProps) {
     super(props);
   }

  public render(): JSX.Element {
  let product:any = this.props.product;
  if(this.props.parentProduct){
    product = this.props.parentProduct;
  }
  /* System Boot Sizing TO DO MODAL */
  let sacScrubDisclosure:any = null;
  if(product.attributes.slug == "ballast-sac-scrub"){
    sacScrubDisclosure =
    <div className="small-centered-text tiny-top-margin">
      <a target="_blank" href="https://assets.hosports.com/pdf/sac-scrub-disclosures.pdf">{'Disclosures'}</a>
    </div>
  }

  /* prop 65 Warning */
  let prop65Warning:any = null;
  if(product.attributes.category == "lDtB8joWup"){
    prop65Warning =
    <div style={{"marginTop": "15px", marginBottom:"15px"}}>
      <div className="tiny-padding light-grey-background" style={{padding:"5px"}}>
        <div className="row">
          <div className="small-2 medium-1 centered-text">
            <img className="full-width" style={{"maxWidth": "20px", "marginTop": "12px"}} src="https://assets.hosports.com/img/general/warning-triangle.png" />
          </div>
          <div className="small-10 medium-11 left-text">
            <p style={{fontSize:'12px'}}><b>{'WARNING:'}</b><br />
              <span className="subheading">{'This product can expose you to chemicals including Diisononyl phthalate (DINP), which is known to the State of California to cause cancer. For more information go to www.P65Warnings.ca.gov.'}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  }

  /* comp vest warning */
    let compVestWarning:any = null;
    if(product.attributes.subcategory == "sIXaPDCLFP" ||
      product.attributes.slug == "waterski-vests-syndicate-rebel" ||
      product.attributes.slug == "waterski-vests-syndicate-pro"
    ){
      compVestWarning =
      <Collapsible trigger ={
        <div className="white-background small-centered-text tiny-top-margin">
          <div className="tiny-padding red-background">
            <h6 className="white">{'Non Coast Guard Approved'}</h6>
          </div>
          <div className="tiny-padding">
            <p className="subheading">
              {'This is a comp vest and is not a life jacket. Please use a coast guard approved life jacket in waterways that require a coast guard approved life jacket.'}
            </p>
          </div>
        </div>
        }>
        <img className="full-width" style={{"maxWidth":"300px"}} src="https://assets.hosports.com/img/general/life-jacket-warning.png" />
      </Collapsible>
    }

    return (
      <div>
        {compVestWarning}
        {prop65Warning}
        {sacScrubDisclosure}
      </div>
    );
  };
};


export default Disclaimers;
